export default __webpack_public_path__ + "static/media/banana.3101cea3.gif";